"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { EditorTagBadge, EditorTagBadgeIcon } from '../../ComboBox/Badges/EditorTagBadge/index.mjs';
import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import { forwardRef } from 'react';
import { makeDataField } from '../index.mjs';
import { useFormComponents } from '../use-form-components.mjs';

const ExtractTimeFormula = forwardRef(
  (props, ref) => {
    return /* @__PURE__ */ jsxs(EditorTagBadge, { variant: "formula", ref, onClick: props.onClick, onDelete: props.onDelete, children: [
      /* @__PURE__ */ jsx(EditorTagBadgeIcon, { type: SvgIconType.Function }),
      " Extract time"
    ] });
  }
);
function ExtractTimeFormulaDropdown(props) {
  const { DataBuilderForm } = useFormComponents();
  const { onChange, variablesSchema, optionFactories, formula } = props;
  function handleVariableChange(value) {
    onChange?.({
      $extractTime: value
    });
  }
  const field = makeDataField({
    schema: {
      title: "Extract time from",
      type: "string",
      format: "date-time"
    },
    value: formula.value,
    variablesSchema,
    optionFactories
  });
  return /* @__PURE__ */ jsx(DataBuilderForm, { field, onChange: handleVariableChange });
}

export { ExtractTimeFormulaDropdown, ExtractTimeFormula as default };
